import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Dropdown, Label, Segment, Tab, Table } from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';

interface Props {
  selectedElementDat: any;
  commScheme: any;
  setMappingData: any;
  externalApi: boolean;
  externalApiMsg?: boolean;
  setTokenChecker: any;
  setTokenvalue: (tokenvalue: string) => void;
  tokenvalue: string;
  setEmttokenchecker: (emttokenchecker: boolean) => void;
  setApisave: (apisave: boolean) => void;
}

function APICardBox({
  selectedElementDat,
  commScheme,
  setMappingData,
  externalApi,
  externalApiMsg,
  setTokenChecker,
  setTokenvalue,
  tokenvalue,
  setEmttokenchecker,
  setApisave,
}: Props) {
  const { ApiStore, RolesAndPermissionsStore, ElementStore, activityStore } =
    useStore();
  const { selectedActivity: activity } = activityStore;
  const { rolesRegistry, loadRoles } = RolesAndPermissionsStore;
  const {
    apiInput,
    getFetchData,
    selectedMetadataElement,
    selectedAssetIdElement,
    templateMetadataElement,
  } = ApiStore;
  const [apiSubStr, setApiSubStr] = useState<any>(commScheme.url);
  const [getMethodData, setGetMethodData] = useState([]); //get method fetch all data
  const [showLabelGet, setShowLabelGet] = useState(commScheme.method);
  const [communicationMsgStr, setCommunicationMsgStr] = useState<any>(
    commScheme.body,
  );
  const [apitoken, setApitoken] = useState<any>('');

  useEffect(() => {
    let condition = apitoken !== undefined && apitoken !== null ? true : false;
    setEmttokenchecker(condition);
    // eslint-disable-next-line
  }, [apitoken]);

  useEffect(() => {
    TextAreaGetter();
    setTokenvalue(document.getElementsByClassName('api-extApi')[0]?.innerHTML);
    // eslint-disable-next-line
  }, [externalApi, tokenvalue]);

  const TextAreaGetter = () => {
    // eslint-disable-next-line
    // (externalApi ) && (document.getElementsByClassName("api-extApi")[0].innerHTML = "");
    externalApi && setEmttokenchecker(true);
  };

  //setting the value of getmethod for showing dynamic labels
  useEffect(() => {
    setGetMethodData(getFetchData);
  }, [getFetchData]);

  ///Draggable function
  const addClass = (elem: any, className: any) => {
    const classNames = elem.className.split(' ');
    if (classNames.indexOf(className) === -1) {
      classNames.push(className);
    }
    elem.className = classNames.join(' ');
  };

  // const selectElem = ( selector:any ) => {
  //   return document.querySelector( selector )
  // }

  const selectAllElems = (selector: any) => {
    return document.querySelectorAll(selector);
  };

  // const removeElem = ( elem:any ) => {
  //   return elem ? elem.parentNode.removeChild( elem ) : false
  // }

  const nativeBindDraggable = (elems: any = false) => {
    elems = elems || selectAllElems('.native_drag');
    if (!elems) {
      // No element exists, abort
      return false;
    } else if (elems.outerHTML) {
      // if only a single element, put in array
      elems = [elems];
    }
    // else it is html-collection already (as good as array)

    for (let i = 0; i < elems.length; i++) {
      // For every elem in list, attach or re-attach event handling
      elems[i].dataset.transferreference = `transit_${new Date().getTime()}`;
      elems[i].ondragstart = function (e: any) {
        if (!e.target.id) {
          e.target.id = new Date().getTime();
        }
        const globalWin: any = window;
        globalWin.inTransferMarkup = e.target.outerHTML;
        globalWin.transferreference = elems[i].dataset.transferreference;
        // updateMsg(e.target.outerHTML)
        addClass(e.target, 'dragged');
      };
    }
  };

  const nativeBindWriteRegion = (elems: any = false) => {
    elems = elems || selectAllElems('.native_receiver');
    if (!elems) {
      // No element exists, abort
      return false;
    } else if (elems.outerHTML) {
      // if only a single element, put in array
      elems = [elems];
    }
    // else it is html-collection

    for (let i = 0; i < elems.length; i++) {
      elems[i].ondragover = function (e: any) {
        e.preventDefault();
        return false;
      };
      elems[i].ondrop = function (e: any) {
        receiveBlock(e);
      };
    }
  };

  const receiveBlock = (e: any) => {
    e.preventDefault();
    const globalWin: any = window;
    const content = globalWin.inTransferMarkup;

    globalWin.inTransferMarkup = '';

    let range = null;
    if (document.caretRangeFromPoint) {
      // Chrome
      range = document.caretRangeFromPoint(e.clientX, e.clientY);
    } else if (e.rangeParent) {
      // Firefox
      range = document.createRange();
      range.setStart(e.rangeParent, e.rangeOffset);
    }
    const sel: any = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    e.target.focus();

    document.execCommand('insertHTML', false, content);
    sel.removeAllRanges();

    // reset draggable on all blocks, esp the recently created
    nativeBindDraggable(
      document.querySelector(
        `[data-transferreference='${globalWin.transferreference}']`,
      ),
    );
    // removeElem( selectElem( '.dragged' ) );
    updateMsg('dragData');
    updateUrl('dragData');
    return false;
  };

  useEffect(() => {
    nativeBindDraggable();
    nativeBindWriteRegion();
    // eslint-disable-next-line
  }, []);
  ////End

  useEffect(() => {
    if (rolesRegistry.size <= 1) loadRoles();
  }, [rolesRegistry.size, loadRoles]);

  const setApiMethod = (e: any, data: any) => {
    apiInput.getApiInitScheme.forEach((comData: any) => {
      if (comData.status === commScheme.status) {
        setShowLabelGet(data.value);

        if (data.value === 'GET') {
          ElementStore.setGetMethodClicked = true;
        } else {
          ElementStore.setGetMethodClicked = false;
        }
        comData.method = data.value;
      }
    });
  };

  const updateMsg = (param: string) => {
    apiInput.getApiInitScheme.forEach((data: any) => {
      if (data.status === commScheme.status) {
        const currentMsg: any =
          document.getElementsByClassName('api-body')[0].innerHTML;
        const currentTabIndex: number = commScheme.status;
        if (param === 'dragData') {
          let arrPus: any = [];
          const tabContainer: any = document.querySelector('.api-body');
          const elementTag = tabContainer.querySelectorAll('C');

          elementTag.forEach((data: any) => {
            // eslint-disable-next-line
            arrPus.push(
              '"' +
                data.textContent.replace(/ /g, '') +
                '"' +
                ':' +
                '"' +
                data.id +
                '"',
            );
          });
          data.body = currentMsg;
          data.model = '{' + arrPus + '}';
        }
        ApiStore.getapiBody(currentMsg, currentTabIndex);
      }
    });
  };

  const updateUrl = (param: string) => {
    apiInput.getApiInitScheme.forEach((data: any) => {
      if (data.status === commScheme.status) {
        const currentSub: any =
          document.getElementsByClassName('api-url')[0].innerHTML;
        const currentTabIndex: number = commScheme.status;
        if (param === 'dragData') {
          const arrPus: any = [];
          const tabContainer: any = document.querySelector('.api-url');
          const elementTag = tabContainer.querySelectorAll('C');

          elementTag.forEach((data: any) => {
            // eslint-disable-next-line
            arrPus.push(
              '"' +
                data.textContent.replace(/ /g, '') +
                '"' +
                ':' +
                '"' +
                data.id +
                '"',
            );
          });
          data.url = currentSub;
          data.urlmodel = '{' + arrPus + '}';
        }
        ApiStore.getApiSub(currentSub, currentTabIndex);
      }
    });
  };

  const updateExternalApi = (param: string) => {
    const toekchecking: any =
      document.getElementsByClassName('api-extApi')[0].innerHTML;
    toekchecking && setApisave(false);
    // setTokenChecker(true);
    apiInput.getApiInitScheme.forEach((data: any) => {
      if (data.status === commScheme.status) {
        const currentSub: any =
          document.getElementsByClassName('api-extApi')[0].innerHTML;
        commScheme.isExternalAPI = true;
        const currentTabIndex: boolean = commScheme.isExternalAPI;
        if (param === 'dragData') {
          const arrPus: any = [];
          const tabContainer: any = document.querySelector('.api-extApi');
          const elementTag = tabContainer.querySelectorAll('C');
          elementTag.forEach((data: any) => {
            // eslint-disable-next-line
            arrPus.push(
              '"' +
                data.textContent.replace(/ /g, '') +
                '"' +
                ':' +
                '"' +
                data.id +
                '"',
            );
          });
          data.isExternal = true;
          data.token = currentSub;
          data.token = '{' + arrPus + '}';
        }
        ApiStore.getApiExternal(currentSub, currentTabIndex);
      }
    });
  };

  useEffect(() => {
    setCommunicationMsgStr(commScheme.body);
  }, [commScheme.body]);

  useEffect(() => {
    if (document.getElementsByClassName('api-url')[0] === undefined) {
      setApiSubStr('');
    } else {
      setApiSubStr(commScheme.url);
    }
    // eslint-disable-next-line
  }, [commScheme.url]);

  useEffect(() => {
    setApitoken(commScheme.token);
    ApiStore.subtasktokendata(commScheme.token);
    // apiInput.getApiInitScheme = commScheme.token
    // eslint-disable-next-line
  }, [commScheme.token, externalApi]);

  const optionList = () => {
    return [
      {
        key: 1,
        text: 'PUT',
        value: 'PUT',
      },
      {
        key: 2,
        text: 'POST',
        value: 'POST',
      },
      {
        key: 3,
        text: 'GET',
        value: 'GET',
      },
    ];
  };

  const staticasset = [
    {
      key: selectedAssetIdElement.asset_Id?.toString(),
      text: 'Asset_Id',
      value: 'Asset_Id',
    },
    {
      key: selectedAssetIdElement.element_Id?.toString(),
      text: 'Element_Id',
      value: 'Element_Id',
    },
    {
      key: selectedAssetIdElement.template_Id?.toString(),
      text: 'Template_Id',
      value: 'Template_Id',
    },
    {
      key: selectedAssetIdElement.task_Id?.toString(),
      text: 'Task_Id',
      value: 'Task_Id',
    },
    {
      key: selectedAssetIdElement.subTask_Id?.toString(),
      text: 'SubTask_Id',
      value: 'SubTask_Id',
    },
    {
      key: activity?.id,
      text: 'Item_Id',
      value: 'Item_Id',
    },
  ];

  const getSelectedRole = () => {
    if (commScheme !== undefined || commScheme.method !== null) {
      return commScheme.method;
    } else {
      return '';
    }
  };

  const metaDataList = (e: any, data: any, key: string) => {
    setMappingData((countryList: any) => [
      ...countryList,
      { [data.value]: key },
    ]);
  };

  const handleValue = (key: string) => {
    let data = apiInput?.getApiInitScheme[0]?.data;
    if (data.length > 0) {
      let finalValue = JSON.parse(data);
      if (finalValue) {
        for (let i = 0; i <= finalValue.length - 1; i++) {
          for (let x in finalValue[i]) {
            if (finalValue[i][x] === key) {
              return x.toString();
            }
          }
        }
        return '';
      } else {
        return '';
      }
    }
  };

  return (
    <Tab.Pane>
      <Segment.Group>
        <Segment compact>
          <div className="split">
            <label>Kindly Enter Body in JSON format</label>
            <div
              className="api-body text native_receiver"
              // placeholder="Kindly Enter Body in JSON format"
              contentEditable="true"
              style={{ color: 'black', border: '0px' }}
              dangerouslySetInnerHTML={{
                __html: communicationMsgStr,
              }}
              onKeyUp={() => {
                updateMsg('textData');
              }}
            ></div>
            <div className="fields">
              {/* <CsCardBox selectedElementDat={selectedElementDat} roleValueData={roleValueData}/>           */}
              <Segment>
                <Segment>
                  <Label.Group color="blue" size="medium">
                    <Label as="a" style={{ width: '100%' }}>
                      <p>Select Method:</p>
                      <Dropdown
                        style={{ width: '100%' }}
                        placeholder="--Select Method--"
                        search
                        selection
                        options={optionList()}
                        value={getSelectedRole()}
                        onChange={(e: any, data: any) => setApiMethod(e, data)}
                      />
                    </Label>

                    <Label as="a" style={{ width: '100%' }}>
                      <p>Enter Request URL:</p>
                      <div
                        contentEditable="true"
                        className="api-url native_receiver"
                        // placeholder="Enter the URL..."
                        dangerouslySetInnerHTML={{
                          __html: apiSubStr,
                        }}
                        onKeyUp={() => {
                          updateUrl('textData');
                        }}
                        suppressContentEditableWarning={true}
                      ></div>
                    </Label>
                  </Label.Group>
                </Segment>
                <Segment>
                  <Label.Group color="blue" size="medium">
                    <h5>WorkFlow Components:</h5>
                    {!!selectedElementDat &&
                      selectedElementDat.map((data: any) => {
                        return (
                          <Label
                            as="c"
                            key={data.elementId}
                            className="native_drag"
                            data-type="dateselector"
                            //  contentEditable="false" suppressContentEditableWarning={false}
                            draggable="true"
                            id={data.elementId}
                          >
                            {' '}
                            {data.elementName.replace(/ /g, '_')}{' '}
                          </Label>
                        );
                      })}
                  </Label.Group>
                </Segment>
                <Segment>
                  <Label.Group color="blue" size="medium">
                    <h5>Meta Data Components:</h5>
                    {templateMetadataElement.map((a: any) => (
                      <Label
                        as="c"
                        key={a.key}
                        className="native_drag"
                        data-type="dateselector"
                        contentEditable="false"
                        suppressContentEditableWarning={false}
                        draggable="true"
                        id={a.key}
                      >
                        {a.text}
                      </Label>
                    ))}
                  </Label.Group>
                </Segment>
                <Segment>
                  <Label.Group color="blue" size="medium">
                    <h5>ID's:</h5>
                    {staticasset.map((a: any) => (
                      <Label
                        as="c"
                        key={a.key}
                        className="native_drag"
                        data-type="dateselector"
                        contentEditable="false"
                        draggable="true"
                        id={a.key}
                      >
                        {a.text}
                      </Label>
                    ))}
                  </Label.Group>
                </Segment>
                {showLabelGet === 'GET' && getMethodData.length > 0 && (
                  <Segment
                    style={{
                      overflowY: 'scroll',
                      height: '400px',
                    }}
                  >
                    {/* <Label.Group color="blue" size="medium"> */}

                    {getMethodData?.map((a: any) => {
                      return (
                        <>
                          <Table basic size="small">
                            <Table.Body>
                              {Object.keys(a).map((key: any) => {
                                return (
                                  <Table.Row>
                                    <Table.Cell>{key}</Table.Cell>
                                    <Table.Cell>
                                      <Dropdown
                                        placeholder="MetaData/Elements"
                                        search
                                        selection
                                        options={selectedMetadataElement}
                                        defaultValue={handleValue(key)}
                                        onChange={(e, data) =>
                                          metaDataList(e, data, key)
                                        }
                                      />
                                    </Table.Cell>
                                  </Table.Row>
                                );
                              })}
                            </Table.Body>
                          </Table>
                        </>
                      );
                    })}
                  </Segment>
                )}
              </Segment>
            </div>
          </div>
          {externalApi && (
            <Segment style={{ color: 'black', height: '175px' }}>
              <Label.Group color="blue" size="medium">
                <Label as="a" style={{ width: '100%' }}>
                  <p>Enter Token:</p>
                  <div
                    contentEditable="true"
                    className="api-extApi native_receiver"
                    // placeholder="Enter the Token..."
                    onInput={apitoken}
                    onBlur={apitoken}
                    dangerouslySetInnerHTML={{
                      __html: apitoken,
                    }}
                    onKeyUp={() => {
                      updateExternalApi('textData');
                    }}
                    suppressContentEditableWarning={true}
                  ></div>
                </Label>
              </Label.Group>
            </Segment>
          )}
        </Segment>
      </Segment.Group>
    </Tab.Pane>
  );
}

export default observer(APICardBox);
